import { render, staticRenderFns } from "./BoFavorite.vue?vue&type=template&id=85f4a9c8&"
import script from "./BoFavorite.vue?vue&type=script&lang=js&"
export * from "./BoFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports